import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { userSignUp } from '../../appRedux/actions/Auth';
import IntlMessages from '../../util/IntlMessages';
// import SocialIcon from "../common/SocialIcon";
import { Form, notification, Checkbox, Radio, Drawer } from 'antd';
import _ from 'lodash';
import axios from '../../util/Api';
import { bussinessTypeArray, BASE_URL_ATTACH, MIME_TYPES } from '../../constants/Common';
import moment from 'moment';
import UtilService from '../../services/util';
import Loader from '../../components/common/Loader';
import OpenNotification from '../common/CommonButton/OpenNotification';
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
import InputBlock from '../common/InputBlock';
import SelectOption from '../common/SelectOption';
import Heading from '../common/Heading';
import TermsCondition from '../TermsConditionPopup';

import {
  GET_COUNTRY_LIST,
  FETCH_SELLERS,
  GET_STATE_LIST,
  GET_CITY_LIST,
  SIGNUP_USER_FRONT,
  DIRECT_BUY_NOW,
} from '../../constants/apiConstant';
import { LOCAL_STORAGE_VAR } from '../../constants/Common';
import { signupValidatorBuy } from './SignupValidator';
import TermsConditionPopup from '../TermsConditionPopup';
import { handleConfirmStone } from '../DiamondList/DiamondListFunctions';

export const companyDetail = {
  Country: [
    { value: 'Afghanistan ' },
    { value: 'Albania ' },
    { value: 'Algeria ' },
    { value: 'American Samoa' },
    { value: 'Andorra' },
    { value: 'Angola' },
    { value: 'India' },
  ],
  State: [
    { value: 'Maharashtra ' },
    { value: 'Andhra Pradesh' },
    { value: 'Arunachal Pradesh' },
    { value: 'Assam ' },
    { value: 'Bihar' },
    { value: 'Dadra and Nagar Haveli ' },
    { value: 'Daman and Diu' },
  ],
  City: [
    { value: 'Achalpur' },
    { value: 'Ahmadnagar' },
    { value: 'Akola' },
    { value: 'Amravati' },
    { value: 'AURANGABAD' },
    { value: 'Miraj' },
    { value: 'MUMBAI' },
  ],
};
let isChanged = {};
class QuickSignUpForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      mobileData: '',
      mobileValid: true,
      formData: {
        countryCode: '91',
        firstName: '',
        lastName: '',
        email: '',
        username: '',
        password: '',
        confirmPassword: '',
        companyName: '',
        phone: '',
        mobile: '',
        // address: "",
        // pinCode: "",
        country: {},
        comment: '',

        // state: {},
        // city: {},
        // isTermsCondAgree: false,
        // updateRequired: false,
      },
      countries: [],
      states: [],
      cities: [],
      isDeviceUrl: false,
      errors: null,
      loading: false,
    };
  }

  componentDidMount() {
    let isDeviceUrl = window.location.pathname.includes('/device/signup');
    this.setState({ isDeviceUrl: isDeviceUrl });
    this.fetchCountries();
  }

  fetchCountries() {
    let self = this;

    let obj = {
      // method: "post",
      // url: "/admin/country/paginate",
      ...GET_COUNTRY_LIST,
    };
    UtilService.callApi(obj, function (err, data) {
      if (err && err.data.code === 'E_BAD_REQUEST') {
        return OpenNotification({
          type: 'error',
          title: err.data.message,
        });
      } else if (data && data.code === 'OK') {
        self.setState({
          allCountries: data.data || [],
          countries: data.data || [],
        });
      }
    });
  }

  fetchSellers() {
    let self = this;

    let obj = {
      // method: "post",
      // url: "/front/sellers",
      ...FETCH_SELLERS,
    };
    UtilService.callApi(obj, function (err, data) {
      if (err && err.data.code === 'E_BAD_REQUEST') {
        return OpenNotification({
          type: 'error',
          title: err.data.message,
        });
      } else if (data && data.code === 'OK') {
        self.setState({
          countries: data.data || [],
        });
      }
    });
  }

  handleOnChange(key, value) {
    let { formData } = this.state;
    if (key === 'phone') {
      const re = /^[0-9\b]+$/;
      if (value === '' || re.test(value)) {
        if (formData[key].length === 0) {
          if (value === '0') {
            formData[key] = value.trim();
          } else {
            formData[key] = value.trim();
          }
        } else {
          formData[key] = value.trim();
        }
      }
    } else {
      if (key === 'username') {
        formData[key] = value.trim();
      } else {
        formData[key] = value;
      }
    }
    // delete errors[key];
    let errors = null;
    if (this.state.errors) {
      errors = Object.assign('', this.state.errors);
      delete errors[key];
    }

    this.setState({ formData, errors });
  }

  handleCountryChange(e) {
    // console.log('e', e)
    let self = this;
    let errors = null;
    if (self.state.errors) {
      errors = Object.assign('', this.state.errors);
      delete errors['country'];
    }
    self.setState({ errors });

    let country = this.state.countries.filter((c) => c.id === e)[0];
    // console.log('country', country)
    if (country) {
      let formData = this.state.formData;
      formData.country = country ? country : {};
      // formData.state = {};
      // formData.city = {};
      this.setState(
        {
          formData: formData,
          states: [],
          cities: [],
          allCities: [],
        },
        () => {
          // this.fetchStates(e);
          // this.fetchCities(null, e);
        },
      );
    }
  }

  handleSignup = (e) => {
    e.preventDefault();
    let self = this;

    let reqObj = _.clone(this.state.formData);
    let id = this.props.location.state && this.props.location.state.id;
    reqObj.country = _.isEmpty(reqObj.country) ? null : reqObj.country.id;
    reqObj.emails = _.isEmpty(reqObj.email) ? null : [reqObj.email];
    reqObj.mobiles = _.isEmpty(reqObj.mobile) ? null : [reqObj.mobile];
    reqObj.diamonds = id ? [id] : [];
    if (!reqObj.password) {
      delete reqObj.password;
      delete reqObj.confirmPassword;
    }
    if (!reqObj.username) {
      delete reqObj.username;
    }
    let obj = {
      ...DIRECT_BUY_NOW,
      request: reqObj,
    };
    const errors = signupValidatorBuy({ ...obj.request });
    if (!errors.isValid) {
      self.setState({ errors: errors.errors });
    } else {
      if (self.state.mobileValid) {
        self.setState({ loading: true });
        UtilService.callApi(obj, function (err, data) {
          self.setState({ loading: false });
          if (err && err.data) {
            if (err.data.code === 'E_USER_NOT_FOUND') {
              return OpenNotification({
                type: 'error',
                title: err.data.message,
              });
            } else if (err.data.code === 'E_DUPLICATE') {
              return OpenNotification({
                type: 'error',
                title: err.data.message,
              });
            } else {
              return OpenNotification({
                type: 'error',
                title: err.data.message,
              });
            }
          }

          if (data && data.code === 'OK') {
            self.handleCancel();
            OpenNotification({
              type: 'success',
              title: data.message,
            });
          }
        });
      }
    }
  };

  handleCancel() {
    this.setState({
      formData: {
        firstName: '',
        lastName: '',
        email: '',
        username: '',
        password: '',
        confirmPassword: '',
        countryCode: this.state.formData.countryCode,

        companyName: '',
        // address: "",
        country: {},
        // state: {},
        // city: {},
        // pinCode: "",
        fax: '',
        phone: '',
        phone2: '',
        comment: '',
        mobile: '',
        broker: false,
        brokerName: '',
        brokerEmail: '',
        brokerMobile: '',
        brokerPhoneNo: '',
        // isTermsCondAgree: false,
        // updateRequired: false,
        companyBest: [],
        companyType: '',
        seller: '',
      },
    });
  }

  TermPopup = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  onChange = (e) => {
    this.setState({
      value: e.target.value,
    });
  };

  handleSelectChange = (e) => {
    let dropdownObj = _.clone(this.state.formData);
    dropdownObj[e.target.id] = e.target.value;
    // dropdownObj['country'] = e.target.value

    if (e.target.id === 'country') {
      this.fetchState(e.target.value);
      this.fetchCity(e.target.value);
      dropdownObj.state = '';
      dropdownObj.city = '';
    } else if (e.target.id === 'state') {
      this.fetchCity(e.target.value);
      dropdownObj.city = '';
    }
    this.setState({ formData: dropdownObj });
  };

  handleImgRemove = (name) => {
    this.props.form.resetFields(name);
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: '',
      },
    }));
  };
  onBlur = (name, val) => {
    let self = this;
    let data = {
      [name]: val,
    };

    const errors = signupValidatorBuy(data);
    if (!errors.isValid) {
      self.setState({ errors: errors.errors });
    }
  };
  render() {
    const { formData, errors, countries, states, cities } = this.state;
    return (
      <>
        <div className="loginDetail registerForm">
          <div className="registerMainScroll">
            <Loader loading={this.state.loading} />
            <div className="registerMainBlock">
              <Form
                autoComplete="off"
                // onSubmit={this.handleSignup}
                className=""
              >
                <div>
                  <Heading className="popupInnerTitle" title="Personal Details" />
                  <div className="registerFiledBlock">
                    <InputBlock
                      required
                      onChange={(e) => this.handleOnChange('firstName', e.target.value)}
                      onBlur={(e) => this.onBlur('firstName', e.target.value)}
                      hasError={errors !== null && errors['firstName'] ? errors['firstName'] : false}
                      value={formData.firstName}
                      type="text"
                      label="First Name"
                      placeholder="First Name"
                      name="firstName"
                      id="firstName"
                      autoComplete="nope"
                    />

                    <InputBlock
                      required
                      onChange={(e) => this.handleOnChange('lastName', e.target.value)}
                      onBlur={(e) => this.onBlur('lastName', e.target.value)}
                      hasError={errors !== null && errors['lastName'] ? errors['lastName'] : false}
                      value={formData.lastName}
                      type="text"
                      label="Last Name"
                      placeholder="Last Name"
                    />

                    <InputBlock
                      required
                      onChange={(e) => this.handleOnChange('email', e.target.value)}
                      onBlur={(e) => this.onBlur('email', e.target.value)}
                      hasError={errors !== null && errors['email'] ? errors['email'] : false}
                      value={formData.email}
                      type="text"
                      label="Email"
                      placeholder="Email"
                    />
                    <InputBlock
                      // required
                      onChange={(e) => this.handleOnChange('username', e.target.value)}
                      onBlur={(e) => this.onBlur('username', e.target.value)}
                      hasError={errors !== null && errors['username'] ? errors['username'] : false}
                      value={formData.username}
                      type="text"
                      label="Username"
                      placeholder="Username"
                    />

                    <InputBlock
                      info
                      // required
                      onChange={(e) => this.handleOnChange('password', e.target.value)}
                      onBlur={(e) => this.onBlur('password', e.target.value)}
                      hasError={errors !== null && errors['password'] ? errors['password'] : false}
                      value={formData.password}
                      type="password"
                      label="Password"
                      placeholder="Password"
                    />

                    <InputBlock
                      required={formData.password ? true : false}
                      onChange={(e) => this.handleOnChange('confirmPassword', e.target.value)}
                      onBlur={(e) => this.onBlur('confirmPassword', e.target.value)}
                      hasError={errors !== null && errors['confirmPassword'] ? errors['confirmPassword'] : false}
                      value={formData.confirmPassword}
                      type="password"
                      label="Confirm Password"
                      placeholder="Confirm Password"
                    />
                  </div>
                  <Heading className="popupInnerTitle mt-10" title="Company Information" />
                  <div className="registerFiledBlock">
                    <InputBlock
                      required
                      type="text"
                      label="Company Name"
                      placeholder="Company Name"
                      onBlur={(e) => this.onBlur('companyName', e.target.value)}
                      onChange={(e) => this.handleOnChange('companyName', e.target.value)}
                      value={formData.companyName}
                      hasError={errors !== null && errors['companyName'] ? errors['companyName'] : false}
                    />
                    <InputBlock
                      onChange={(e) => this.handleOnChange('phone', e.target.value)}
                      value={formData.phone}
                      onBlur={(e) => this.onBlur('phone', e.target.value)}
                      hasError={errors !== null && errors['phone'] ? errors['phone'] : false}
                      type="text"
                      label="Phone No"
                      placeholder="Phone No"
                    />
                    <div className="from-group inputBlock countryCodeDropdown">
                      <label className="CommonLabel">
                        Mobile No <span style={{ color: formData.mobile ? 'green' : 'red' }}>*</span>
                      </label>
                      <div className="mobileCodeBlock">
                        <span className="countryCode">+{formData.countryCode}</span>
                        <IntlTelInput
                          onPhoneNumberBlur={(status, value, countryData, number, id) => {
                            this.onBlur('mobile', value);
                            if (status) {
                              this.setState({ mobileValid: true, mobileData: '' });
                            } else {
                              this.setState({ mobileValid: false, mobileData: 'Please enter the valid Phone number.' });
                            }
                          }}
                          format={false}
                          formatOnInit={false}
                          onPhoneNumberChange={(valid, number, d) => {
                            let { formData } = this.state;
                            let errors = null;
                            if (this.state.errors) {
                              errors = Object.assign('', this.state.errors);
                              delete errors['mobile'];
                            }
                            formData['mobile'] = number ? number : '';

                            this.setState({ formData, errors, mobileValid: true, mobileData: '' });
                          }}
                          value={formData.mobile}
                          onSelectFlag={(de, dial, fault) => {
                            let { formData } = this.state;
                            formData['mobile'] = '';
                            formData['countryCode'] = `${dial.dialCode}`;

                            let errors = null;
                            if (this.state.errors) {
                              errors = Object.assign('', this.state.errors);
                              delete errors['mobile'];
                            }

                            this.setState({ formData });
                          }}
                          preferredCountries={['in']}
                          containerClassName="intl-tel-input"
                          inputClassName="form-control"
                          fieldName="mobile"
                          customPlaceholder={(a, obj) => {
                            return `${obj.name}`;
                          }}
                          // placeholder={false}
                        />
                      </div>
                      {errors !== null && errors.mobile ? (
                        <span style={{ color: 'red' }}>{errors.mobile}</span>
                      ) : (
                        !this.state.mobileValid && <span style={{ color: 'red' }}>{this.state.mobileData}</span>
                      )}
                    </div>

                    <SelectOption
                      required
                      hasError={errors !== null && errors['country'] ? errors['country'] : false}
                      // defaultValue="Country"
                      value={!_.isEmpty(formData.country) ? formData.country.name : undefined}
                      placeholder="Select Country"
                      selectValue={countries}
                      onChange={(e) => this.handleCountryChange(e)}
                      label="Select Country"
                      showSearch
                    />

                    <div className="commonTextArea from-group">
                      <label>Remarks</label>
                      <textarea
                        value={formData.comment}
                        onChange={(e) => this.handleOnChange('comment', e.target.value)}
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div className="mt-30 loginButton">
                  <button
                    // disabled={this.state.registerButton}
                    // type="submit"
                    onClick={(e) => this.handleSignup(e)}
                    className="commonButton"
                  >
                    <IntlMessages id="app.BuyNow" />
                  </button>
                  <button onClick={(e) => this.handleCancel(e)} className="commonOutline">
                    <IntlMessages id="app.Cancel" />
                  </button>
                </div>
              </Form>
              <div className="registerLogLink">
                <IntlMessages id="app.already-have-acc" />
                &nbsp;
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    if (this.state.isDeviceUrl) {
                      if (navigator.appVersion.includes('iPhone')) {
                        window.webkit.messageHandlers.LoginCallBack.postMessage('LoginCallBack');
                      } else if (navigator.appVersion.includes('Android')) {
                        window.webkit.LoginCallBack('LoginCallBack');
                      }
                    } else {
                      this.props.history.push('/');
                      // window.location.href = "/dashboard";
                    }
                  }}
                >
                  <IntlMessages id="app.sign-In" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (props) => {
  return {
    ...props,
    loading: props.commonData.loading,
  };
};

export default withRouter(connect(mapStateToProps, { userSignUp })(Form.create({ name: '' })(QuickSignUpForm)));
